import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

export default function useNotifications() {
  const [notifications, setNotifications] = useState([]);

  const pushNotification = (drone, message) => {
    setNotifications(prev => [
      {
        id: uuidv4(),
        droneId: drone.drone_id,
        droneName: drone.drone_name,
        message,
        timestamp: Date.now(),
        read: false
      },
      ...prev
    ]);
  };

  const markAllNotificationsRead = () => {
    setNotifications(prev =>
      prev.map(n => ({ ...n, read: true }))
    );
  };

  return {
    notifications,
    unreadCount: notifications.filter(n => !n.read).length,
    pushNotification,
    markAllNotificationsRead
  };
}
